import { render, staticRenderFns } from "./personal.vue?vue&type=template&id=2857f2ca&scoped=true&"
import script from "./personal.vue?vue&type=script&lang=js&"
export * from "./personal.vue?vue&type=script&lang=js&"
import style0 from "./personal.vue?vue&type=style&index=0&id=2857f2ca&lang=scss&scoped=true&"
import style1 from "./personal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2857f2ca",
  null
  
)

export default component.exports